'use strict';

var _module2 = require('./module');

var _module3 = _interopRequireDefault(_module2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_module3.default.directive('countrySelect', ['$timeout', 'countryService', function ($timeout, countryService) {
    return {
        restrict: "E",
        template: require('./countrySelect.html'),
        require: 'ngModel',
        scope: {},
        link: function link($scope, element, attrs, ngModel) {
            ngModel.$render = function () {
                $scope.value = ngModel.$viewValue;
            };

            attrs.$observe('emptyLabel', function (value) {
                $scope.emptyLabel = value;
            });

            if (attrs.order || attrs.eta) {
                countryService.order = attrs.order;
                countryService.eta = attrs.eta;
                countryService.rebuildCountries();
            }

            $scope.$watch('value', function () {
                ngModel.$setViewValue($scope.value);
                ngModel.$render();
                ngModel.$setValidity('required', !attrs.required || !!$scope.value);
            });

            $scope.countries = countryService.countries;
            $scope.$on('i18nextLanguageChange', function () {
                $timeout(function () {
                    $scope.countries = countryService.countries;
                });
            });

            attrs.$observe('ppdisable', function (value) {
                $scope.ppdisable = value;
            });
        }
    };
}]);


//////////////////
// WEBPACK FOOTER
// ./src/core/countrySelect.js
// module id = 60
// module chunks = 0 2